import * as React from 'react';
import { Rel } from '../../../../../Resource/Types';
import SupportIcon from '../../../../Cutesies/SupportIcon';
import { observer } from 'mobx-react';

interface Props {
  rel: Rel;
}

const MenuItemIcon: React.FC<Props> = ({ rel }) => {
  switch (rel) {
    case 'support':
      return (
        <div className="inline-block mr-1 relative top-[3px] w-4 h-4">
          <SupportIcon />
        </div>
      );
    default:
      return <span />;
  }
};

export default observer(MenuItemIcon);
